import * as React from "react";
import { MoreHorizontal, CheckCircle, Trash2, Droplet } from "lucide-react";
import { useChangeUserSatausMutation } from "@/store/studentApi";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import { CustomAlertDialog } from "./AlertDialog";
import { RootState } from "@/types";

const ActionDropdown = ({ student, studentName, studentLastName }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [changeStatusFn, { isSuccess }] = useChangeUserSatausMutation();
  const { user } = useSelector((state: RootState) => state.user);

  const handleStatusChange = async (status: string) => {
    try {
      await changeStatusFn({
        Token: user?.token,
        data: {
          student,
          status: status,
        },
      });
      toast.success(`Status updated to ${status}!`);
    } catch (error) {
      console.log(error);
      toast.error(`Failed to update status to ${status}`);
    }
  };

  React.useEffect(() => {
    if (isSuccess) {
      toast.success("Status Updated! Check: By Filter");
    }
  }, [isSuccess]);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <MoreHorizontal className="h-5 w-5 text-gray-500" />
      </button>

      {isOpen && (
        <div
          className="absolute right-0 mt-1 w-48 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 transform origin-top-right transition-all duration-200 ease-out animate-in fade-in slide-in-from-top-2"
          onMouseLeave={() => setIsOpen(false)}
        >
          <div className="py-1">
            <CustomAlertDialog
              triggerButton={
                <button className="group flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-red-50 transition-colors duration-150">
                  <CheckCircle className="mr-3 h-4 w-4 text-gray-400 group-hover:text-red-500 transition-colors duration-150" />
                  <span className="group-hover:text-red-700">Activate</span>
                </button>
              }
              title="Activate Student"
              description={`Are you sure you want to activate ${studentName} ${studentLastName}?`}
              onConfirm={() => handleStatusChange("Active")}
            />

            <CustomAlertDialog
              triggerButton={
                <button className="group flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-orange-50 transition-colors duration-150">
                  <Droplet className="mr-3 h-4 w-4 text-gray-400 group-hover:text-orange-500 transition-colors duration-150" />
                  <span className="group-hover:text-orange-700">Drop</span>
                </button>
              }
              title="Drop Student"
              description={`Are you sure you want to drop ${studentName} ${studentLastName}?`}
              onConfirm={() => handleStatusChange("Disable")}
            />

            <CustomAlertDialog
              triggerButton={
                <button className="group flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-red-50 transition-colors duration-150">
                  <Trash2 className="mr-3 h-4 w-4 text-gray-400 group-hover:text-red-500 transition-colors duration-150" />
                  <span className="group-hover:text-red-700">Delete</span>
                </button>
              }
              title="Delete Student"
              description={`Are you sure you want to delete ${studentName} ${studentLastName}?`}
              onConfirm={() => handleStatusChange("Delete")}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
